import * as React from "react";

// Material UI
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
import ToggleButton from "@material-ui/lab/ToggleButton";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
interface TimerAdderProps {
    title: string;
    onValueAdded: (value: number) => void;
}

const TimerAdder = (props: TimerAdderProps) => {
    const useStyles = makeStyles((theme: Theme) =>
        createStyles({
            toggleButton: {
                width: 50,
                height: "100%",
            },
            plusMins: {
                padding: 0,
            },
        })
    );
    const classes = useStyles();
    const [selectedValue, setSelectedValue] = React.useState<number>(10);

    const handleChangeValue = (event: any, value: any) => {
        setSelectedValue(value);
    };

    const handleAddClicked = () => {
        props.onValueAdded(selectedValue);
    };

    const handleMinusClicked = () => {
        props.onValueAdded(selectedValue * -1);
    };

    return (
        <Grid item>
            <Grid container spacing={2} direction="column">
                <Grid item>
                    <Typography variant="subtitle1">{`${props.title}:`}</Typography>
                </Grid>
                <Grid container spacing={1}>
                    <Grid item>
                        <ToggleButtonGroup
                            color="primary"
                            exclusive={true}
                            value={selectedValue}
                            onChange={handleChangeValue}
                        >
                            <ToggleButton value={10} className={classes.toggleButton}>
                                10
                            </ToggleButton>
                            <ToggleButton value={5} className={classes.toggleButton}>
                                5
                            </ToggleButton>
                            <ToggleButton value={1} className={classes.toggleButton}>
                                1
                            </ToggleButton>
                        </ToggleButtonGroup>
                    </Grid>
                    <Grid item>
                        <Grid container direction="column">
                            <Grid item>
                                <Button variant="outlined" className={classes.plusMins} onClick={handleAddClicked}>
                                    +
                                </Button>
                            </Grid>
                            <Grid item>
                                <Button variant="outlined" className={classes.plusMins} onClick={handleMinusClicked}>
                                    -
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default TimerAdder;
